// extracted by mini-css-extract-plugin
module.exports = {"title":"ChangePasswordForm_title__3J8qz","submit":"ChangePasswordForm_submit__2VK5Y","wrapper":"ChangePasswordForm_wrapper__2Qyk_"};